module.exports = __webpack_public_path__ + "media/images/britesparks-3d4b25247cc8e1d8b9f8ef2566c7b915.png";